"use client"

import { cn } from "@/shared/lib/utils"

interface LogoProps {
  size?: "sm" | "md" | "lg"
  showText?: boolean
  className?: string
  priority?: boolean
  tone?: "onDark" | "onLight" | "inverse"
  /** Scale down on narrow viewports (footer / dense layouts). */
  responsive?: boolean
}

const wordmarkSizeClass = {
  sm: "text-[1.45rem]",
  md: "text-[1.7rem]",
  lg: "text-[2rem]",
} as const

const responsiveWordmarkSizeClass = {
  sm: "text-[1.2rem] sm:text-[1.45rem]",
  md: "text-[1.45rem] sm:text-[1.7rem]",
  lg: "text-[1.7rem] sm:text-[2rem]",
} as const

const iconSizeClass = {
  sm: "text-xl",
  md: "text-2xl",
  lg: "text-3xl",
} as const

const wordmarkToneClass = {
  onDark: { brand: "text-white", accent: "text-accent-blue" },
  onLight: { brand: "text-gray-900", accent: "text-accent-blue" },
  inverse: { brand: "text-white", accent: "text-white" },
} as const

export function Logo({
  size = "md",
  showText = true,
  className,
  tone = "onDark",
  responsive = false,
}: LogoProps) {
  const colors = wordmarkToneClass[tone]

  if (!showText) {
    return (
      <div className={cn("flex items-center", className)}>
        <span
          className={cn(
            "select-none font-black leading-none tracking-normal",
            colors.brand,
            iconSizeClass[size]
          )}
        >
          P<span className={colors.accent}>.ai</span>
        </span>
      </div>
    )
  }

  return (
    <div className={cn("flex items-center", className)}>
      <span
        className={cn(
          "block select-none font-black leading-none tracking-normal",
          colors.brand,
          responsive ? responsiveWordmarkSizeClass[size] : wordmarkSizeClass[size]
        )}
      >
        Pleasur<span className={colors.accent}>.ai</span>
      </span>
    </div>
  )
}
